export const domainKeys = [
    'names',
    'codes',
    'relationships',
    'notes',
    'properties',
    'constituents'
];

export const domainDisplayKeys = {
    names: 'name',
    codes: 'code',
    relationships: 'relatedSubstance.name',
    notes: 'note',
    properties: 'name',
    constituents: 'substance.name'
};
